<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>

<style>
#app {
  /* height: 100%; */
  overflow: hidden;
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background-color: #fff;
  color: #303133;
}
body,
html {
  /* height: 100%; */
  width: 100%;
  /* position: fixed; */
  top: 0;
  left: 0;
}
body::-webkit-scrollbar {
  display: none !important;
  width: 2px !important;
  height: 2px !important;
}
::-webkit-scrollbar {
  display: none !important;
  /* width: 2px !important;
  height: 2px !important; */
}
img {
  content: normal !important;
}
</style>
